import {
  FlatActionList,
  FlatActionListItem,
  ProductThumbnail,
  View,
} from "@towersystems/roam-common-native";
import { ProductKitItem } from "@towersystems/roam-common/lib/generated-types";

export interface KitItemsListProps {
  kitItems: ProductKitItem[];
  onAllPress: (kitItem: ProductKitItem) => void;
  disabled?: boolean;
}

export const KitItemsList = ({
  kitItems,
  onAllPress,
  disabled,
}: KitItemsListProps) => {
  if (kitItems.length === 0) {
    return null;
  }

  let items: FlatActionListItem[] = kitItems.map((kitItem) => ({
    key: kitItem.id,
    title:
      kitItem.product?.displayName ||
      kitItem.product?.name ||
      "Unknown Product",
    onPress: () => onAllPress(kitItem),
    subTitle: kitItem.product?.stockNumber,
    disabled,
    trailingAccessory: (
      <ProductThumbnail
        size="small"
        quantity={kitItem.quantity}
        imageUrl={kitItem.product?.image?.path}
      />
    ),
  }));

  return <FlatActionList items={items} style={{ overflow: "visible" }} />;
};
